import gql from 'graphql-tag';

const createBillMe = gql`
mutation createBillMe($member: MemberInput) {
  createBillMe(input: $member) {
    personId
    firstName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    spouseId
  }
}
`;

export default createBillMe;



// WEBPACK FOOTER //
// ./src/app/mutations/createBillMe.js